export const ENVIRONMENT = {
  DEV: "dev",
  UAT: "uat",
  PROD: "prod",
};
export const StafflistConstants = {
  StaffList: "Employee List",
  ConflictStaffList: "Conflict Staff",
  Sortby: "Sort by",
  Baserole: "Base role",
  CreatedDate: "Created Date",
  UserValidation: "User Validation",
  Roles: "Roles & Applications",
  ConflictingReason: "Conflicting Reason",
  Last: "Last used Application",
  Status: "Status",
  StaffName: "Staff Name",
};
export const Constants = {
  Title: "DEM",
  Hello: "Hello, ",
  Welcome: "Welcome, ",
  Search: "Search for anything...",
  help: "Need Help with DEM?",
  Applications: "Applications",
  User: "User Groups",
  noUser: "No, of user",
  seeTutorial: "See Tutorial",
  TotalStaff: "Total Staff",
  UserGroups: "User Groups",
  Demographics: "Demographics",
  RecentActivities: "Recent Activities",
  Roles: "Roles",
  AppsAndPermissions: "Application's And Permissions",
  ValidationPendingStaff: "Pending Staff List ",
  StaffName: "Staff Name",
  AdhaarAuthentication: "Adhaar Authentication",
  Actions: "Actions",
  Department: "Department",
  GroupRole: "Group Role",
  BaseRole: "Base Role",
  Users: "Users",
  ViewAll: "View All",
  EditProfile: "Edit Profile",
  AccountCreatedOn: " Account Created on :",
  Id: "Employee ID :",
  NoofUsers: "No. of Users",
  Permissions: "Permissions",
  Action: "Action",
  ApproveUser: "APPROVE USER",
  ActivateUser: "ACTIVATE USER",
  AcceptUser: "ACCEPT",
  RejectUser: "REJECT",
  UserReject: "REJECT USER",
  SameDealer: "Same Dealer",
  OtherDealer: "Other Dealer",
  deactivateUser: "DEACTIVATE USER",
  overview: "Overview",
  quickLinks: "Quick Links",
  alertRole: "Please add role(s) in order to proceed further.",
};

export const OnboardConstants = {
  Title: "DEM",
  UserProfileSettup: "Staff Profile Setup and Validation ",
  Fillin: "Fill in all the necessary fields to onboard the user.",
  steps: " Steps to complete",
  PersonalInformation: "Personal Information",
  EducationalInformation: "Educational Information",
  ProfessionalInformation: "Professional Information",
  FirstName: "First Name*",
  LastName: "Last Name",
  DateOfBirth: "Date of Birth",
  MobileNo: "Mobile Number*",
  EmailAddress: "Email Address",
  AdhaarNumber: "Adhaar number",
  Address: "Address*",
  NameofCollege: "Name of the Institute/College/School*",
  Percentage: "Percentage %*",
  YearOfPassing: "Year of Passing*",
  EducationBoard: "Education Board*",
  Next: "Next",
  DLExpiryDate: " DL Expiry date",
  WorkExperience: "Work Experience",
  BankAccountDetails: "Bank account details ",
  UploadPassbook: "Upload Passbook",
  UploadConsentForm: "Upload Consent Form",
  DragDrop: "    Drag & Drop or ",
  choosefile: "choose file ",
  toupload: "to upload",
  Supportedformats: "  Supported formats : Jpeg, pdf",
  AdhaarAuthentication: "Adhaar Authentication",
  AadharUserConsent: "Aadhar User Consent",
  RolesApplicationsandPermissions: "Roles, Applications and Permissions",
  AdhaarPopupTitle: " Adhaar verified sucessfull",
  AdharSuccessfullMsg: "The OTP is verified.",
  Done: "Done",
  Action: "Actions",
  Back: "Back",
  CapturePhoto: "Capture Photo",
  facealredyExist: " face alredy Exist",
  CaptureDesc:
"Capture image for facial recognition login",
  Yes: "Yes",
  No: "No",
  Reset: "Reset",
  consentMessage1: "When you click on ",
  consentMessage2:
    ", a confirmation message will be sent to the user for collecting their consent for accepting the ",
  consentMessage3:
    "The user profile will be created but will be activated only after e-KYC verification is successfully completed. In order to continue with e-KYC verification, the user needs to provide their consent.",
  termsAndcondition: "“Terms and Conditions and Privacy Policy”.",
  createProfile: "Create Profile",
  skip: "Skip",
  continue: "Continue to e-KYC",
  popupMessage: "Do you want to continue with the e-KYC Verification Flow?",
  failedMessage:
    "The Account was unable to create for the user. Please check with your admin or go back and try again.",
  StaffVerification: "Staff Verification",
  DrivingLicense: "Driving License",
  BankDetails: "Bank Details",
  PanCard: "PAN Card",
  ConsentLinkDescription:
    "The consent link has been sent to the staff. This page will not be enabled until the staff accepts the consent. If the staff has already accepted the consent, please refresh the page and try again.",
  DrivingLicenseDetails: "Driving License Details",
  VerifyStaffDetailTitle: "No Details added yet",
  VerifyStaffDetailDescription: "click on the below button to add the ",
  AddDetails: "Add Details",
  verify: "Verify",
  details: "Details",
  saveDetails: "Save Details",
  verifyStaffPopupTitle: "Staff Verification Successful",
  verifyStaffFailedPopupTitle: "Staff Verification Failed",
  verifyStaffPopupMessage:
    "The employee has been successfully verified with the details of their",
  dlVerifiedSuccessMessage: "Your DL with Number ",
  panVerifiedSuccessMessage: "Your PAN ",
  bankVerifiedSuccessMessage: "Your Account Number ",
  successMessage: "was successfully verified",
  resendConsentSMS: "Consent message sent successfully",
  resendSMSSuccessMessage:
    "The consent link has been sent to the registered phoneNumber",
  clearAll: " Clear All",
  ekycDescription:
    "It is mandatory to complete the e-KYC using one of the options below. Please ensure this is done in order for the user to get onboarded.",
  verified: "Verified",
  popUpMessageToGoBackToDashboard:
    "Click the below button to go back to the dashboard",
  goBackToDashboard: "Go to HomePage",
};

export const PlaceHolderText = {
  firstName: "Enter your First Name",
  lastName: "Enter your Last Name",
  gender: "Enter or select your gender",
  mobileNumber: "Enter your Mobile Number",
  email: "Enter your Email Address",
  maritalStatus: "Enter or select your Marital Status",
  address: "Enter your Address",
  city: "Select your City",
  country: "Select your Country",
  state: "Select your State",
  zipCpde: "Enter your ZIP Code",
  drivingLicenseNumber: "Enter your DL Number",
  dateOfExpiry: "Enter your DL Date of Expiry",
  qualification: "Enter or select your Qualification",
  instituteName: "Enter your Name of the Institute",
  grade: "Enter or select your Grade",
  yearOfPassing: "Enter your year of passing",
  educationBoard: "Enter your education board",
  role: "Enter your role",
  organizationName: "Enter your organization name",
  experience: "Enter your experience",
  department: "Select your Department",
  group: "Enter or Select your group role",
  baseRole: "Enter or select your base role",
  type: "Enter or select your type",
  specialization: "Enter or Select Product Specialization",
  // Enter or Select Product Specialization (multiple)
  certification: "Enter or Select Training (multiple)",
  branch: "Enter or Select Branch Name (Default)",
  bank: "Enter or select bank",
  beneficiary: "Enter your Beneficiary Name",
  accountNumber: "Enter your Bank Account Number",
  panNumber: "Enter your PAN",
  upi: "Enter your UPI ID",
  linkedMobileNumber: "Enter your Bank Linked Mobile Number",
  ifscCode: "Enter IFSC Code",
  joiningDate: "Enter your Joining Date ",
  reportingPersonName: "Enter or select the name",
  others: "Enter the designation",
  designation: "Enter or select the designation",
  reportingRole: "Enter or select the reporting role",
  lastWorkingDay: "Last Working Day",
  reasonForExit: "Select the reason for exit",
  additionalComments: "Additional comments",
  selectTheLastWorkingDay: "Enter or select the last working day",
};

export const MenuItems = [
  "Dashboard",
  "Employee List",
  "Applications",
  "User Roles",
  "Reports",
  "Location",
  "Help",
  "Setting",
];

export const MenuItemsPath: any = {
  Dashboard: "/dashboard",
  "Staff List": "/stafflist",
  Applications: "/comingsoon",
  "User Roles": "/comingsoon",
  Reports: "/comingsoon",
  Location: "/locationMaster",
  Help: "/comingsoon",
  Setting: "/comingsoon",
};

export const StaffListConstants = {
  Title: "Employee List",
  DOB: "Date of Birth",
  StaffListBreadCrumb: "Employee List > ",
  PersonalInformation: "Personal Information",
  ProfessionalInformation: "Professional Information",
  BankAccountDetails: "Bank account details",
  RolesAndPermissions: "Roles and Permissions",
  WorkExperience: "Work Experience",
  EmployeeId: "Employee Id",
  OfficialEmailAddress: "Official Email Address",
  JoiningDate: "Joining Date",
  UserName: "User Name",
  EmployeeType: "Employee Type",
  DealerId: "Dealer Id",
  Password: "Password",
  SelectBaseRole: "Select Base Role",
  Role: "Role*",
  OrganisationName: "OrganisationName*",
  NumberOfYears: "Number of Years Experience*",
  Applications: "Applications",
  NoRolesAssignedYet: "No Roles Assigned Yet",
  ToAssignTheRolesClickBelowButton:
    "To Assign the roles Click on the “Add Role” Button Above.",
  AddRole: "Add Role",
  Roles: "Roles",
  Groups: "Groups",
  Gender: "Gender*",
  MaritalStatus: "Marital Status*",
  joiningDate: "Joining Date",
  Nationality: "Nationality",
  City: "City",
  State: "State",
  Country: "Country",
  ZipCode: "Zip Code",
  FirstName: "First Name",
  LastName: "Last Name",
  MobileNumber: "Mobile Number",
  AadharNumber: "Aadhar Number",
  EducationalInformation: "Educational Information",
  InstituteName: "Name of the Institute/College/School",
  HighestQualification: "Qualification*",
  Percentage: "Percentage %",
  YearOfPassing: "Year of Passing",
  BankName: "Bank Name",
  IFSCCode: "IFSC Code",
  UPIID: "UPI ID",
  BankLinkedMobileNumber: "Bank Linked Mobile Number",
  PANNumber: "PAN",
  BeneficiaryName: "Beneficiary Name",
  BankAccountNumber: "Bank Account Number",
  Documents: "Documents",
  Cancel: "Cancel",
  Save: "Save",
  SendAadharVerificationLink: "Send Aadhar Verification Link",
  department: "Department",
  Group: "Group*",
  SelectType: "Select Type",
  SelectProductSpecialization: "Select Product Specialization (multiple)",
  MultipleBranchAccess: "Multiple Branch Access",
  Department: "Department*",
  GroupRole: "Group Role",
  BaseRole: "Base Role*",
  baseRole: "Base Role",
  Type: "Type",
  NoApplicationsAddedYet: "No Applications added yet",
  ToAddTheApplicationsToTheUserClickOnAddApplicationButtonBelow:
    "To add the applications to the user, Click on Assign Application button above.",
  AddApplication: "Assign Application",
  SelectApplication: "Select Application",
  ApplicationAddedSuccessfully: "Application Added Successfully",
  TheSuperApplicationHasBeenAddedSuccessfully:
    "The “Super application” has been added successfully",
  ProductSpecialization: "Product Specialization",
  trainingCertification: "Training",
  Action: "Action",
  DrivingLicence: "Driving Licence (DL) Number",
  DLDateOfExpiry: "DL Date of Expiry",
  educationalDetails: "Educational Details",
  RoleAdditionSuccessMessage: "User Role Added Successfully",
  Okay: "Okay",
  Confirm: "Confirm",
  ErrorMessage: "Mapping already exists with the provided combination.",
  UserRegisteredMessage: "User Profile Created.",
  UserApprovedSuccessfully: "User Approved Sucessfully",
  UserApprovedDescription: "Click below button to proceed",
  UserRegisteredDescription: "Click below button to add role",
  AssignPermissions: "ASSIGN PERMISSIONS",
  Application: "Application",
  Pemissions: "Pemissions",
  viewPermissions: "view permissions",
  WarningErrorMessage: "Base Role cannot be empty.Please Select a Base Role",
  BaseRoleErrorMessage:
    "Base Role cannot be empty, Atleast one Base role should be added",
  SpecializationMultiErrorMessage:
    "Specialization is multi select for the role",
  SpecializationErrorMessage: "Specialization is not multi select for the role",
  RemoveUserDescription:
    "Would you like to proceed with removing the Dealer Management System (DMS) app from Sumeet's application list?",
  AreYouSure: "Are you sure?",
  ConflictApproveConfimationMessage:
    "Do you want to approve the user to move to other dealership?",
  ConflictRejectConfimationMessage:
    "Do you want to reject this user to stay in your dealership?",
  RejectConfirmationMessage: "Do you want to reject this user?",
  ApprovedSuccessMessage: "User approved sucessfully",
  RejectedSuccessMessage: "User rejected sucessfully",
  APIErrorMessage: "Something went wrong....Pls try again",
  branch: "Branch Name (Default)",
  editFlowSucessMsg: "User info saved sucessfully.",
  applicationErrorMessage:
    "The application you were selected is already been assigned to user.",
  ActivatedSuccessMessage: "User activated sucessfully",
  DeactivatedSuccessMessage: "User deactivated sucessfully",
  errorInAddingRole: "Unable to Add User Role",
  addBankDetails: "Add Bank Details",
  staffValidation: "Staff Validation",
  sendConsentSMSLink: "Send Consent SMS Link",
  designation: "Designation",
  others: "Others",
  reportingRole: "Reporting Role",
  reportingPersonName: "Reporting Person Name",
  reportingRoleErrorMessage:
    "No user available for this role, please select another role",
  dateOfJoining: "1950-01-01",
  staffExitFlowTitle: "Staff Exit Process",
  staffExitFlowBreadCrumb: "Staff Exit Process",
  staffInformation: "Staff Information",
  staffInformationDescription:
    "Fill in all the necessary fields to offboard the user.",
  reasonForExit: "Reason for exit",
  otherReason: "Enter other reason",
  selectAnAction: "Select an action",
  pleaseSelectAnyOneOptionToContinue: "Please Select any one option to continue",
  staffExitSuccessMessage1:"User Offboarding Successfull",
  staffExitSuccessMessage2:"All necessary fields have been filled, and access has been revoked.",
  additionalCommentErrorMessage:"Please enter the additional comments",
  role:"Role",
  organizationName:"Organization name",
  noOfYearsExperience:"Number of years/Months Experience",
  qualification:"Qualification",
  nameOfInsitute:"Name of the Institute/College/School",
  location:"Location",
  grade:"Grade",
  yearOfPassing:"Year of Passing",
  EducationBoard:"Education Board",
};

export const ConfirmationDialog = {
  approveUser: "Do you want to approve the user?",
  activateUser: "Do you want to activate the user?",
  rejectUser: "Do you want to reject the user?",
  inActivateUser: "Do you want to deactivate the user?",
};
export const LoginConstants = {
  Login: "Login",
  PhoneNumberandOTP: "Phone Number and OTP",
  FaceRecognition: "Face recognition",
  EmployeeIdAndPassword: "Employee id and password",
  Fingerprint: "Fingerprint",
  OrLoginWith: "Or login with",
  CapturePhoto: "Capture Photo",
  AutenticateandLogin: "Autenticate and Login",
  Retake: "Retake",
  Confirm: "Confirm",
  ConfirmAndLogin: "Confirm and Login",
  FaceRecgnitionText:
    "To log in, click to capture your photo for face verification",
  EmailIdtext: "Enter your Employee ID and Password",
  FingerPrintText: "To log in, scan your fingerprint below",
  PhoneNumberText: "Click the button below to login",
  CaptureImage:"Capture Image"
};

export const DashboardConstants = {
  addNewStaff: "Add New Staff",
  verifyStaff: "Verify Staff",
  assignApplication: "Assign Application",
  manageRoles: "Manage Roles",
  addNewStaffDescription: "Complete the onboarding process for new staff",
  verifyStaffDescription: "Verify Aadhar status or send verification links.",
  assignApplicationDescription:
    "Manage Applications of staff based on their roles.",
  manageRolesDescription:
    "Assigning and controlling staff roles within the system",
  download: "Download",
  filters: "Filters",
  sort: "Sort",
  add: "Add",
  empId: "EMP ID:",
  employeeId: "Employee ID",
};
export const ButtonText = {
  confirmAndSubmit: "Confirm and Submit",
  tvsmUserLogin: "TVSM User Login",
};
export const ExitStaffConstants = {
  other: "Other",
};

export const ErrorConstant = {
  firstNameError: "First Name cannot be empty",
  dateOfBirthError: "Date of Birth cannot be empty",
  genderError: "Gender cannot be empty",
  maritalStatusError: "Marital Status cannot be empty",
  primaryPhoneNumberExistsError: "Phone Number Already Exists with this Dealer",
  phoneNumberExistsWithOtherDealerError:
    "Phone Number Already Exists with other Dealer",
  primaryPhoneNumberError: "Phone Number should be 10 digits",
  primaryPhoneNumberEmpty: "Phone Number cannot be empty",
  addressError: "Address cannot be empty",
  cityError: "City cannot be empty",
  stateError: "State cannot be empty",
  countryError: "Country cannot be empty",
  zipCodeError: "Zip Code cannot be empty",
  degreeNameError: "Qualification cannot be empty",
  universityError: "Institute/College/school cannot be empty",
  percentageError: "Percentage cannot be empty",
  yearOfPassingEmptyError: "Year of passing cannot be empty",
  yearOfPassingError: "Year of passing should be four digits",
  educationBoardError: "Education board cannot be empty",
  roleNameError: "Role Name cannot be empty",
  organizationNameError: "Organization Name cannot be empty",
  yearOfExpError: "Year of Experience cannot be empty",
  bankNameError: "Bank Name cannot be empty",
  beneficiaryNameError: "Beneficiary Name cannot be empty",
  accountNumberError: "Account Number cannot be empty",
  ifscCodeError: "IFSC Code cannot be empty",
  upiIdError: "UPI ID cannot be empty",
  panNumberError: "PAN cannot be empty",
  passbookError: "Please Upload the Passbook",
  consentFormError: "Please Upload the Signed Consent Form",
  faceImageError: "Profile photo cannot be empty",
  departmenError: "Deparment cannot be empty",
  groupError: "Group can not be empty",
  baseRoleError: "Base Role can not be empty",
  dateOfBirthAgeCheckError: "User age with less than 18 years is not allowed",
  designationError: "designation can not be empty",
};

export const UserStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  PENDING: "PENDING_ACTIVE",
  CONFLICT: "CONFLICT",
  PASSIVE: "PASSIVE",
};

export const UserStatusAction = {
  CONFLICT_APPROVE: "CONFLICT_APPROVE",
  CONFLICT_REJECT: "CONFLICT_REJECT",
  ACTIVATE: "ACTIVATE",
};

export const NUMERIC = /^[0-9]*$/;
export const ALPHA_NUMERIC_WITH_SPACE_HYPHEN = /^[A-Za-z0-9\s-]*$/;
export const ALPHABET_WITH_SPACE = /^[A-Za-z\s]*$/;
export const ALPHA_NUMERIC = /^[A-Za-z0-9]*$/;
export const PERCENTAGE =
  /^(100(?:\.0{0,2})?|\d{0,2}(?:\.\d{0,2})?|0(?:\.\d{0,2})?)$/;

export const sessionConstants = {
  SESSION_EXPIRED: " Session Expired. Please login again!",
};
export const ekycType = {
  bank: "BANK",
  pan: "PAN",
  drivingLisense: "DL",
};

export const consentConstant = {
  consentHeader: "Privacy Policy, Terms and Conditions",
  privacyPolicy: "Privacy Policy",
  termsAndConditions: "Terms and Conditions",
  checkBoxDetails: "I confirm that I have read and understood the",
  submitConsent: " Submit Consent",
  submissionSucessTitle: "Submission Successful!",
  submissionSucessDescription:
    "Thank you for accepting our Terms and Conditions and Privacy Policy. Your submission has been successfully recorded.",
  done: "Done",
  andAgreeToThe: "and agree to the",
  consentRefreshHeader: "Something went wrong",
  consentRefreshDescription:
    "Please reload the page or try again after some time",
  refresh: "Refresh",
  consentAlreadyCompleted: "Consent already completed",
  consentAlreadyCompletedDescription:
    "Go back and continue the e-KYC procedure",
};

export const UserValidationStatus = {
  ekycVerified: "e-KYC Verified",
  consentPending: "Staff consent pending",
  ekycPending: "e-KYC Pending",
};

export const pageRouteConstants = {
  onboardRoute: "/onboard",
  dashBoardRoute: "/dashboard",
  staffListRoute: "/staffList",
  staffDetailRoute: "/staffDetail/:userid",
  comingSoonRoute: "/comingsoon",
  tcppRoute: "/1",
  locationMaster: "locationMaster",
  ssoLogin: "/login",
  tcpp: "/1",
  userExitFlow: "/exitFlow/:userid",
  helpRoute:"/help"
};

export const b2cErrorCode = {
  monthlyConfirmationError: "MONTHLY_CONFIRMATION_LOGIN_ERROR",
  loginError: "UMS_LOGIN_ERROR",
};

export const ErrorMessage = {
  monthlyConfirmationErrorTitle: "Face Recognition Login Reminder",
  monthlyConfirmationError:
    "hasn't logged in using face recognition this month. To keep your account active, please log in via face recognition now. ",
  loginError: "Unable to login,Please contact administrator",
};


export const urlParameterConstants={
  appId: "app_id",
  callbackUrl : "callback_uri",
}
